module.exports = __webpack_public_path__ + "static/media/sniper.83de213a.svg";